import script from "./ds-form-group.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20DsFormFieldValueType%5B%5D"
export * from "./ds-form-group.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20DsFormFieldValueType%5B%5D"

const __exports__ = script;

export default __exports__